(() => {
  const money = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
  };

  const drawer = document.querySelector('[data-nv-cart-drawer]');
  const backdrop = document.querySelector('[data-nv-cart-backdrop]');
  const closeBtn = document.querySelector('[data-nv-cart-close]');
  const cartItems = document.querySelector('[data-nv-cart-items]');
  const subtotal = document.querySelector('[data-nv-cart-subtotal]');
  const progressText = document.querySelector('[data-nv-progress-text]');
  const progressBar = document.querySelector('[data-nv-progress-bar]');
  const stickyBuy = document.querySelector('[data-nv-sticky-buy]');

  const openCart = () => {
    if (!drawer || !backdrop) return;
    backdrop.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeCart = () => {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    document.documentElement.style.overflow = '';
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  };

  const renderCart = (cart) => {
    if (!cartItems) return;

    if (!cart.items || cart.items.length === 0) {
      cartItems.innerHTML = '<p class="nv-cart-empty">Your cart is empty.</p>';
    } else {
      cartItems.innerHTML = cart.items.map((item) => `
        <div class="nv-cart-item">
          <div>
            <strong>${item.product_title}</strong>
            <span>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Qty ${item.quantity}</span>
          </div>
          <div>
            <strong>${money(item.final_line_price)}</strong>
            <button class="nv-cart-remove" type="button" data-nv-remove-key="${item.key}">Remove</button>
          </div>
        </div>
      `).join('');
    }

    if (subtotal) subtotal.textContent = money(cart.total_price);

    const goalDollars = Number(document.querySelector('[data-nv-cart-drawer]')?.dataset.goal || '75') || 75;
    const goal = goalDollars * 100;
    const percent = Math.min(100, Math.round((cart.total_price / goal) * 100));

    if (progressBar) progressBar.style.width = `${percent}%`;
      if (progressText) {
        if (cart.total_price >= goal) {
          progressText.textContent = 'FREE shipping unlocked — you are set.';
        } else {
      progressText.textContent = `${money(goal - cart.total_price)} away from FREE shipping.`;
      }
    }
  };

  const refreshCart = async () => {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  };

  const addToCart = async ({ variantId, quantity = 1, sellingPlan = '' }) => {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      let message = 'Add to cart failed';
      try {
        const error = await response.json();
        message = error.description || error.message || JSON.stringify(error);
      } catch (e) {}
      throw new Error(message);
    }
    return response.json();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('[data-nv-bundle-form]')) return;

    event.preventDefault();

    const selected = form.querySelector('input[name="bundle"]:checked');
    const button = form.querySelector('button[type="submit"]');

    if (!selected || !selected.dataset.variantId || !button) return;

    const originalText = button.textContent;

    if (selected.dataset.available === 'false') {
      button.textContent = 'Selected option is sold out';
      button.disabled = true;
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1800);
      return;
    }

    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      await addToCart({
        variantId: selected.dataset.variantId,
        quantity: selected.dataset.quantity || 1,
        sellingPlan: selected.dataset.sellingPlan || ''
      });

      await refreshCart();
      openCart();
      button.textContent = 'Added ✓';

      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 900);
    } catch (error) {
      console.error('[NAVAREY] Add to cart failed:', error);
      button.textContent = 'Could not add — check product sales channel';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = originalText;
      }, 2400);
    }
  });

  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-nv-remove-key]');
    if (remove) {
      const key = remove.dataset.nvRemoveKey;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshCart();
      return;
    }

    const bump = event.target.closest('[data-nv-bump-add]');
    if (bump) {
      const originalText = bump.textContent;
      bump.textContent = 'Adding...';
      bump.disabled = true;

      try {
        await addToCart({ variantId: bump.dataset.variantId, quantity: 1 });
        await refreshCart();
        bump.textContent = 'Added ✓';
      } catch (error) {
        bump.textContent = 'Try again';
        bump.disabled = false;
        setTimeout(() => { bump.textContent = originalText; }, 1400);
      }
      return;
    }

    if (event.target.closest('[data-nv-cart-close]') || event.target.matches('[data-nv-cart-backdrop]')) {
      closeCart();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCart();
  });

  const offer = document.querySelector('#offer');
  if (stickyBuy && offer && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      stickyBuy.hidden = entry.isIntersecting;
    }, { threshold: 0.08 });
    observer.observe(offer);

    window.addEventListener('scroll', () => {
      if (window.scrollY > 620) stickyBuy.hidden = false;
    }, { passive: true });
  }

  refreshCart().catch(() => {});
})();
